/**
 * L2-R7: moved to @miq/utils (lib/misc/first-element.ts). This shim keeps the old import path
 * working (including through the `@shared/functions` barrel); new code should import from
 * '@miq/utils'.
 */
export { firstElement } from '@miq/utils';
